export const galleryImages = [
  {
    src: "/assets/images/car1.png",
    alt: "car1",
  },
  {
    src: "/assets/images/car2.png",
    alt: "car2",
  },
  {
    src: "/assets/images/car3.png",
    alt: "car3",
  },
  {
    src: "/assets/images/car4.png",
    alt: "car4",
  },
  {
    src: "/assets/images/Audi-1.png",
    alt: "Audi-1",
  },
  {
    src: "/assets/images/Audi-2.png",
    alt: "Audi-2",
  },
  {
    src: "/assets/images/BMW-3serie.png",
    alt: "BMW-3serie",
  },
  {
    src: "/assets/images/BMW-4serie.png",
    alt: "BMW-4serie",
  },
  {
    src: "/assets/images/BMW-5serie.png",
    alt: "BMW-5serie",
  },
  {
    src: "/assets/images/Ford-Transit.png",
    alt: "Ford-Transit",
  },
  {
    src: "/assets/images/Jaguar-XF.png",
    alt: "Jaguar-XF",
  },
  {
    src: "/assets/images/MB-A.png",
    alt: "MB-A",
  },
  {
    src: "/assets/images/MB-A45.png",
    alt: "MB-A45",
  },
  {
    src: "/assets/images/MB-E.png",
    alt: "MB-E",
  },
  {
    src: "/assets/images/MB-Vito.png",
    alt: "MB-Vito",
  },
  {
    src: "/assets/images/Peugeot-Partner.png",
    alt: "Peugeot-Partner",
  },
  {
    src: "/assets/images/tuning-car-1.png",
    alt: "tuning-car-1",
  },
  {
    src: "/assets/images/tuning-car-2.png",
    alt: "tuning-car-2",
  },
  {
    src: "/assets/images/VW-Caddy.png",
    alt: "VW-Caddy",
  },
  {
    src: "/assets/images/VW-Polo.png",
    alt: "VW-Polo",
  },
  {
    src: "/assets/images/VW-Polo1.2.png",
    alt: "VW-Polo1.2",
  },
  {
    src: "/assets/images/VW-Transporter.png",
    alt: "VW-Transporter",
  },
];
